import { SpyneTrait, ViewStream } from "spyne";

export class CodePlaygroundExamplesDefine extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlaygroundDefine$";

    super(context, traitPrefix);
  }

  static codePlaygroundDefine$HelloWorld() {
    const props = {
      tagName: "h1",
      style: "font-family:sans-serif;",
      data: "Hello World",
    };
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return `
      class MyViewStream extends ViewStream {
        
        constructor(props={}{
          props.tagName = 'h1';
          
          props.data = 'Hello World';
       
        }
      
      
      }
      
      
      new MyViewStream.appendToDom(document.body);
      `;
  }

  static codePlaygroundDefine$HelloWorld1() {
    const props = {
      tagName: "h1",
      style: "font-family:sans-serif; color:orange;",
      data: "Hello World",
    };
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return `
      class MyViewStream extends ViewStream {
        
        constructor(props={}{
          props.tagName = 'h1';
          props.style = "color:orange;",
          props.data = 'Hello World';
       
        }
      
      
      }
      
      
      new MyViewStream.appendToDom(document.body);
      `;
  }
}
